
import React from 'react';

export const ServicesSection: React.FC = () => {
  const services = [
    {
      icon: 'ri-money-euro-circle-line',
      title: 'Kostenersparnis',
      description: 'Bereits in den ersten 90 Tagen um etwa 7 Prozent',
      color: 'bg-green-100 text-green-600',
      highlight: '7% in 90 Tagen'
    },
    {
      icon: 'ri-government-line',
      title: 'Fördermittel',
      description: 'Wir sichern die aktuell vorhandenen Fördermitteln, die Ihnen zustehen',
      color: 'bg-blue-100 text-blue-600',
      highlight: 'Ø 52.000 EUR'
    },
    {
      icon: 'ri-team-line',
      title: 'Mitarbeiterentwicklung',
      description: 'Entwicklung, Weiterbildung und Steigerung der Fähigkeiten Ihrer Mitarbeiter',
      color: 'bg-purple-100 text-purple-600',
      highlight: 'Qualifikation'
    },
    {
      icon: 'ri-robot-line',
      title: 'Automatisierung',
      description: 'Automatisierung von allen kaufmännischen Aufgaben in Ihrem Betrieb',
      color: 'bg-orange-100 text-orange-600',
      highlight: 'Vollautomatisch'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Finanzoptimierung',
      description: 'Optimierung Ihrer Finanzen, Lösung von Zahlungsherausforderungen',
      color: 'bg-red-100 text-red-600',
      highlight: 'Cashflow+'
    },
    {
      icon: 'ri-brain-line',
      title: 'KI-Integration',
      description: 'Künstliche Intelligenz seriös planbar und ohne Risiko einsetzen',
      color: 'bg-indigo-100 text-indigo-600',
      highlight: 'Zukunftssicher'
    }
  ];

  return (
    <section id="leistungen" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Was erwartet Sie?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Folgende Themen werden wir in Ihrem Betrieb aktivieren:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow duration-300">
              <div className={`w-16 h-16 ${service.color} rounded-full flex items-center justify-center mb-6`}>
                <i className={`${service.icon} text-2xl`}></i>
              </div>
              
              <div className="mb-4">
                <span className="bg-yellow-100 text-yellow-800 text-sm font-semibold px-3 py-1 rounded-full">
                  {service.highlight}
                </span>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">Besondere Erfolge</h3>
          <p className="text-lg mb-6">
            In den letzten Monaten konnten wir im Durchschnitt <span className="font-bold text-yellow-300">52.000 EUR</span> 
            für die teilnehmenden Unternehmen erfolgreich beantragen.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
              <div className="text-2xl font-bold text-yellow-300 mb-2">100%</div>
              <div className="text-sm">Erfolgsquote Fördermittel</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
              <div className="text-2xl font-bold text-yellow-300 mb-2">90 Tage</div>
              <div className="text-sm">Bis erste Ergebnisse</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
              <div className="text-2xl font-bold text-yellow-300 mb-2">24/7</div>
              <div className="text-sm">Support verfügbar</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
